module.exports = __webpack_public_path__ + "6b1d0241b17924093a949b028f509ea4.MP3";